import { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import Box from "@material-ui/core/Box";
import { Select, IconButton } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Autocomplete from "@material-ui/lab/Autocomplete";

import CloseIcon from "@material-ui/icons/Close";

import FormControl from "@material-ui/core/FormControl";
import Button from "@material-ui/core/Button";
import HomeIcon from "@material-ui/icons/Home";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Container from "@material-ui/core/Container";
import { styled } from "@material-ui/core/styles";
import "tui-grid/dist/tui-grid.css";
import Grid from "@toast-ui/react-grid";
import "tui-pagination/dist/tui-pagination.css";
import "tui-date-picker/dist/tui-date-picker.css";
import "tui-time-picker/dist/tui-time-picker.css";
import gridHearderSize from "../Shared/Css/Productivity/Productivity.css";
import ProductivityLoading from "./ProductivityLoading";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },

  root: {
    width: "18px",
    height: "18px",
    margin: "5px 0px 0px 0px",
    padding: "0px 0px 0px 5px",
  },
  // Applied to <FormControlLabel />
  label: {
    fontSize: 12,
    margin: "8px 0px 0px 0px",
    padding: "0px 0px 0px 5px",
    // border: '1px solid blue'
  },
}));

const CssAutocomplete = styled(Autocomplete)({
  // 1. 테두리 색상 (OutlinedInput의 테두리 클래스 타겟팅)
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#59b9ea",
  },
  // 2. 내부 텍스트 스타일 (Input 요소 타겟팅)
  "& .MuiInputBase-input": {
    WebkitTextFillColor: "green", // 텍스트 색상 (우선순위 높음)
    color: "white", // 텍스트 색상 (fallback)
    textAlign: "left", // 텍스트 중앙 정렬
  },
});

function Productivity() {
  //사번복고화시작
  const [pwloading, setPwLoading] = useState(0); //실행시 한번만 권한가지기
  const [urlpw, setUrlpw] = useState(0); //실행시 매번 권한가져오기
  const [loginGongjang, setLoginGongjang] = useState([]); //로그인 공장자료담기

  const [loading, setLoading] = useState(false);
  const [gongjang, setGongjang] = useState({ value: "" }); //공장선택
  const [customer, setCustomer] = useState([]); //고객업체명담기/코드
  const [jacUpJang, setJacUpJang] = useState(""); //생산작업장
  const [valueSelectCustomer, setValueSelectCustomer] = useState(null); //업체변경시
  const [getCustomerList, setGetCustomerList] = useState([]);

  const [startDate, setStartDate] = useState(""); //매출검색시작날짜
  const [endDate, setEndDate] = useState(""); //매출검색끝날날짜

  //히스토리사용
  const history = useHistory();

  const classes = useStyles(); //사용자스탕일설정

  //사번복고화종료
  //------------------------------------------------------세션복고화시작
  const pwBog = () => {
    const pwNo = parseInt(sessionStorage.getItem("100") - 660620); //사번복구화
    //console.log(pwNo);
    pwNo > 0 ? setPwLoading(pwNo) : setPwLoading();
  };

  const pwLogin = () => {
    const pwNoPlus = parseInt(sessionStorage.getItem("100") - 660620); //사번복구화
    setUrlpw(pwNoPlus);
  };

  useEffect(() => {
    pwBog();
    pwLogin();
    // setStartDate(moment().format('YYYY-MM-DD')) //시작일자
    // setEndDate(moment().format('YYYY-MM-DD'))   //끝날일자
    if (moment().date() >= 26) {
      // 오늘이 26일 이상이면: 이번 달 26일부터 다음 달 25일까지
      setStartDate(moment().date(26).format("YYYY-MM-DD"));
      // setEndDate(moment().add(1, "months").date(25).format("YYYY-MM-DD"));
      setEndDate(moment().add(1, "months").format("YYYY-MM-DD"));
    } else {
      // 오늘이 25일 이하이면: 전월 26일부터 이번 달 25일까지
      setStartDate(moment().subtract(1, "months").date(26).format("YYYY-MM-DD"));
      // setEndDate(moment().date(25).format("YYYY-MM-DD"));
      setEndDate(moment().format("YYYY-MM-DD"));
    }
    if (pwloading !== urlpw) {
      window.location.assign("/AcountLogin/Login");
    }
  }, [pwloading, urlpw]);

  //공장소속찾기
  useEffect(() => {
    if (pwloading > 0) {
      GetSelectLoginGongjang(pwloading); //인수를 넘겨야 함.
    }
  }, [pwloading]); // pwloading이 변경될 때마다 실행

  //사원등록 사번으로 공장공장소속찾기
  const GetSelectLoginGongjang = async (pwloading) => {
    await axios
      .get("/api/Saengsanseong/Sabun", {
        params: {
          SabunNo: pwloading,
        },
      })
      .then((res) => {
        setLoginGongjang(res.data);
      });
  };

  // 고객업체 찾기
  useEffect(() => {
    GetSelectCustomer();
  }, []);

  //고객업체찾기
  const GetSelectCustomer = async () => {
    await axios.get("/InvoiceReact/UpcheMasterIndex").then((res) => {
      setCustomer(res.data);
    });
  };
  //사용자등록에서 공장을 가져옴
  const gongjangtData = useMemo(
    () => [
      { label: "", value: "" },
      { label: "정진/제콥", value: null },
      ...(String(pwloading) === "20131101" ? [{ label: "정진P&G", value: "정진피엔지" }] : []),
      ...loginGongjang.map((item) => ({
        label: item.pwd_user_gojang_gubun,
        value: item.pwd_user_gojang_gubun,
      })),
    ],
    [pwloading, loginGongjang]
  );

  //업체 데이타뿌리기
  const selectData = useMemo(
    () =>
      customer.map((item) => ({
        label: item.upche_sanghoupche_sangho,
        value: item.upche_code,
      })),
    [customer]
  );

  //생산작업장
  const JacUpJangHandle = (event) => {
    setJacUpJang(event.target.value);
  };

  //조회버튼
  const handleSubmitSerche = (e) => {
    e.preventDefault();
    const DataSerche = {
      // s_Id: 30,
      공장구분: gongjang?.value ? gongjang.value : null,
      업체코드: valueSelectCustomer?.value ? valueSelectCustomer.value : null,
      생산작업장: jacUpJang ? jacUpJang : null,
      생산성시작: startDate ? startDate : null, //생선성시작일
      생산성종료: endDate ? endDate : null, //생산성종료일
    };
    const jungJinJangBi = ["자동수지도포", "수동수지도포", "수동캠록도포", "제콥생산납품", "제콥도포관리", "제콥도포별정"];
    const jcoupJangBi = ["수동피막피착", "자동피막_AB", "정진생산납품", "정진피막관리", "정진피막별정"];

    if (gongjang.value === "정진피엔지" && jungJinJangBi.includes(jacUpJang)) {
      alert("경고: 정진P&G 선택시 제이콥[작업장]을 선택할 수 없습니다.");
      setLoading(false);
      return; //함수 실행을 여기서 중단하여 API 호출을 막습니다.
    } else if (gongjang.value === "(주)제이콥" && jcoupJangBi.includes(jacUpJang)) {
      alert("경고: 제이콥 선택시 정진P&G[작업장]을 선택할 수 없습니다.");
      setLoading(false);
      return; //함수 실행을 여기서 중단하여 API 호출을 막습니다.
    }
    const urlButtonSerche = "/api/Saengsanseong";
    axios
      .get(urlButtonSerche, {
        params: {
          SangSanSeongGojang: DataSerche.공장구분,
          SangSanSeongUpcheCode: DataSerche.업체코드,
          SangSanSeongJacUpJang: DataSerche.생산작업장,
          SangSanSeongStartDate: DataSerche.생산성시작,
          SangSanSeongEndDate: DataSerche.생산성종료,
        },
      })
      .then((res) => {
        setGetCustomerList(res.data);
        setLoading(true);
        //console.log(res.data);
      })
      .finally(function () {
        setLoading(false);
        //항상실행됨
      });
  };

  //console.log(`업체: ${valueSelectCustomer}`);
  //console.log(`작업장: ${jacUpJang}`);

  const rows = useMemo(() => {
    return getCustomerList.map((row, index) => {
      const baseRow = {
        id: row.id,
        공장명: row.공장명,
        일자: new Date(row.일자),
        요일: row.요일,

        출하피막금액합계: row.all_출하피막금액합계,
        출하도포금액합계: row.all_출하도포금액합계,
        출하전체금액합계: row.all_출하전체금액합계,

        직접시간Hr: row.직접시간Hr,
        간접시간Hr: row.간접시간Hr,
        전체시간Hr: row.직접시간Hr + row.간접시간Hr,

        직접인원수: row.직접인원수,
        간접인원수: row.간접인원수,
        전체인원수: row.전체인원수,

        직접생산성Hr: row.직접생산성Hr,
        전체생산성Hr: row.전체생산성Hr,

        인당직접생산금액: row.인당직접생산금액,
        인당전체생산금액: row.인당전체생산금액,

        일일직접금액합계: row.일일직접금액합계,
        일일간접금액합계: row.일일간접금액합계,
        일일총금액합계: row.일일총금액합계,

        직접자재비용합계: row.직접자재비용합계,
        전체자재비용합계: row.전체자재비용합계,

        파막금액비율: row.파막금액비율,
        도포금액비율: row.도포금액비율,
      };
      //업체 조회했을경우
      if (valueSelectCustomer !== null || jacUpJang !== "") {
        baseRow.출하피막금액합계 = row.업체출하피막금액합계;
        baseRow.출하도포금액합계 = row.업체출하도포금액합계;
        baseRow.출하전체금액합계 = row.업체출하전체금액합계;
        //업체 공란처리했을경우
      } else {
        baseRow.출하피막금액합계 = row.all_출하피막금액합계;
        baseRow.출하도포금액합계 = row.all_출하도포금액합계;
        baseRow.출하전체금액합계 = row.all_출하전체금액합계;
        if (valueSelectCustomer === null) {
          baseRow.영업이익 = row.영업이익;
          baseRow.경상이익 = row.경상이익;
        }
      }

      return baseRow;
    });
  }, [getCustomerList, valueSelectCustomer, jacUpJang]); // 의존성 배열

  const columns = useMemo(() => {
    return [
      { name: "id", header: "id", align: "center", width: 50 }, // 최소 기본값
      { name: "공장명", header: "공장", align: "center", width: 80 },
      {
        name: "일자",
        header: "일자",
        align: "center",
        width: 85,
        summary: {
          summaryType: ["min", "max"],
        },
        formatter: function (ev) {
          if (!ev.value) return "";
          const date = moment(ev.value);
          const dayOfWeek = date.day(); // 0: 일요일, 6: 토요일
          let color = "white"; // 평일 기본색
          if (dayOfWeek === 0) {
            // 일요일
            color = "pink";
          } else if (dayOfWeek === 6) {
            // 토요일
            color = "blue";
          }
          return `<div style="color:${color}; font-weight:300;">${date.format("YYYY-MM-DD")}</div>`;
        },
      },
      {
        name: "요일",
        header: "요일",
        align: "right",
        width: 50,
        formatter: function (ev) {
          if (!ev.value) return "";
          let color = "black";
          const weekday = String(ev.value).trim();

          if (weekday === "일요일") {
            color = "pink";
          } else if (weekday === "토요일") {
            color = "blue";
          }
          return `<div style="color:${color}; font-weight:300;">${ev.value}</div>`;
        },
      },

      {
        name: "출하피막금액합계",
        header: "피막금액",
        align: "right",
        width: 95,
        formatter: function (ev) {
          const value = ev?.value; // 안전하게 접근
          return `<div style="color:orange;">${value != null ? Number(value).toLocaleString("ko-KR") : ""}</div>`;
        },
      },
      {
        name: "출하도포금액합계",
        header: "도포금액",
        align: "right",
        width: 95,
        formatter: function (ev) {
          const value = ev?.value; // 안전하게 접근
          return `<div style="color:orange;">${value != null ? Number(value).toLocaleString("ko-KR") : ""}</div>`;
        },
      },
      {
        name: "출하전체금액합계",
        header: "전체금액",
        align: "right",
        width: 95,
        formatter: function (ev) {
          const value = ev?.value; // 안전하게 접근
          return `<div style="color:orange;">${value != null ? Number(value).toLocaleString("ko-KR") : ""}</div>`;
        },
      },

      { name: "직접시간Hr", header: "직접", align: "right", width: 50 },
      { name: "간접시간Hr", header: "간접", align: "right", width: 50 },
      { name: "전체시간Hr", header: "전체", align: "right", width: 50 },

      { name: "직접인원수", header: "직접", align: "right", width: 50 },
      { name: "간접인원수", header: "간접", align: "right", width: 50 },
      { name: "전체인원수", header: "전체", align: "right", width: 50 },

      {
        name: "직접생산성Hr",
        header: "직접",
        align: "right",
        width: 73,
        formatter: function (ev) {
          return `<div style="color:green;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },
      {
        name: "전체생산성Hr",
        header: "전체",
        align: "right",
        width: 73,
        formatter: function (ev) {
          return `<div style="color:green;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },

      {
        name: "인당직접생산금액",
        header: "직접",
        align: "right",
        width: 80,
        formatter: function (ev) {
          return `<div style="color:purple;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },
      {
        name: "인당전체생산금액",
        header: "전체",
        align: "right",
        width: 80,
        formatter: function (ev) {
          return `<div style="color:purple;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },

      {
        name: "일일직접금액합계",
        header: "직접",
        align: "right",
        width: 80,
        formatter: function (ev) {
          return `<div style="color:deepskyblue;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },
      {
        name: "일일간접금액합계",
        header: "간접",
        align: "right",
        width: 80,
        formatter: function (ev) {
          return `<div style="color:deepskyblue;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },
      {
        name: "일일총금액합계",
        header: "전체",
        align: "right",
        width: 80,
        formatter: function (ev) {
          return `<div style="color:deepskyblue;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },

      {
        name: "직접자재비용합계",
        header: "직접",
        align: "right",
        width: 92,
        formatter: function (ev) {
          return `<div style="color:greenyellow;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },
      {
        name: "전체자재비용합계",
        header: "전체",
        align: "right",
        width: 92,
        formatter: function (ev) {
          return `<div style="color:greenyellow;">${ev.value.toLocaleString("ko-KR")}</div>`;
        },
      },

      {
        name: "파막금액비율",
        header: "정진",
        align: "right",
        width: 57,
        formatter: function (ev) {
          return `<div style="color:orange;">${ev.value}</div>`;
        },
      },
      {
        name: "도포금액비율",
        header: "제콥",
        align: "right",
        width: 57,
        formatter: function (ev) {
          return `<div style="color:orange;">${ev.value}</div>`;
        },
      },
      {
        name: "영업이익",
        header: "영업이익",
        align: "right",
        width: 95,
        formatter: function (ev) {
          return `<div style="color:teal;">${ev.value != null ? ev.value.toLocaleString("ko-KR") : ""}</div>`;
        },
      },
      {
        name: "경상이익",
        header: "경상이익",
        align: "right",
        width: 95,
        formatter: function (ev) {
          return `<div style="color:teal;">${ev.value != null ? ev.value.toLocaleString("ko-KR") : ""}</div>`;
        },
      },
    ];
  }, []);

  //혜더 복합칼럼설정
  const header = {
    height: 95,
    complexColumns: [
      {
        // header: "출하금액",
        header: "출하금액",

        name: "출하금액",
        childNames: ["출하피막금액합계", "출하도포금액합계", "출하전체금액합계"],
      },
      {
        header: "근무시간",
        name: "근무시간",
        childNames: ["직접시간Hr", "간접시간Hr", "전체시간Hr"],
      },
      {
        header: "근무인원",
        name: "근무인원",
        childNames: ["직접인원수", "간접인원수", "전체인원수"],
      },
      {
        header: "생산성",
        name: "생산성",
        childNames: ["직접생산성Hr", "전체생산성Hr"],
      },
      {
        header: "인당생산액",
        name: "인당생산액",
        childNames: ["인당직접생산금액", "인당전체생산금액"],
      },
      {
        header: "근무임금",
        name: "근무인금",
        childNames: ["일일직접금액합계", "일일간접금액합계", "일일총금액합계"],
      },
      {
        header: "일별자재비",
        name: "일별자재비",
        childNames: ["직접자재비용합계", "전체자재비용합계"],
      },
      {
        header: "매출점유율",
        name: "매출점유율",
        childNames: ["파막금액비율", "도포금액비율"],
      },
      {
        header: "경영평가",
        headerRenderer: {
          type: "html",
          options: {
            html: '<span style="font-size: 24px; font-weight: bold;">경영평가</span>',
          },
        },

        name: "경영평가",
        childNames: ["영업이익", "경상이익"],
      },
      {
        header: "일일결산현황",
        headerClassName: gridHearderSize.tuiGridHeaderArea,
        name: "생산성결산",
        childNames: ["id", "공장명", "일자", "요일", "출하피막금액합계", "출하도포금액합계", "출하전체금액합계", "직접시간Hr", "간접시간Hr", "전체시간Hr", "직접인원수", "간접인원수", "전체인원수", "직접생산성Hr", "전체생산성Hr", "인당직접생산금액", "인당전체생산금액", "일일직접금액합계", "일일간접금액합계", "일일총금액합계", "직접자재비용합계", "전체자재비용합계", "파막금액비율", "도포금액비율", "영업이익", "경상이익"],
      },
    ],
  };

  //그리드 합계부분
  //합게부분 변수에 담기
  let totalSum_출하피막금액합계 = 0;
  let totalSum_출하도포금액합계 = 0;
  let totalSum_출하전체금액합계 = 0;
  const summary = {
    height: 30,
    position: "bottom", // or 'top'
    columnContent: {
      id: {
        template(summary) {
          return `
          <div align="center"><strong>합계</strong></div>
          <div align="center"><strong>평균</strong></div>
        `;
        },
      },
      일자: {
        template(summary) {
          if (!summary.min || !summary.max) {
            return `<div align="right"></div>`; // 로딩 중 또는 데이터 없을 때
          }
          const startDate = new Date(summary.min);
          const endDate = new Date(summary.max);
          const diffInDays = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
          // yyyy-mm-dd 형식으로 포맷팅
          const formatDate = (date) => {
            const yyyy = date.getFullYear();
            const mm = String(date.getMonth() + 1).padStart(2, "0");
            const dd = String(date.getDate()).padStart(2, "0");
            return `${yyyy}-${mm}-${dd}`;
          };
          return `
              <div align="center">${formatDate(startDate)}</div>
              <div align="center">${formatDate(endDate)}</div>
              <div align="center">${diffInDays.toLocaleString("ko-KR")}일</div>
            `;
        },
      },
      출하피막금액합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          // 외부 변수(savedTotalSum)에 현재 컬럼의 합계 값을 '복사'해 넣습니다.
          if (typeof sum === "number") {
            totalSum_출하피막금액합계 = sum;
          }
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
             <div style="text-align:right; padding-right:0; margin-right:0; color:orange;">${sumText}</div>
             <div style="text-align:right; padding-right:0; margin-right:0; color:orange;">${avgText}</div>
          `;
        },
      },
      출하도포금액합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          // 외부 변수(savedTotalSum)에 현재 컬럼의 합계 값을 '복사'해 넣습니다.
          if (typeof sum === "number") {
            totalSum_출하도포금액합계 = sum;
          }
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
             <div style="text-align:right; padding-right:0; margin-right:0; color:orange;">${sumText}</div>
             <div style="text-align:right; padding-right:0; margin-right:0; color:orange;">${avgText}</div>
          `;
        },
      },
      출하전체금액합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          // 외부 변수(savedTotalSum)에 현재 컬럼의 합계 값을 '복사'해 넣습니다.
          if (typeof sum === "number") {
            totalSum_출하전체금액합계 = sum;
          }
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
             <div style="text-align:right; padding-right:0; margin-right:0; color:orange;">${sumText}</div>
             <div style="text-align:right; padding-right:0; margin-right:0; color:orange;">${avgText}</div>
          `;
        },
      },
      직접시간Hr: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div align="right">${sumText}</div>
            <div align="right">${avgText}</div>
          `;
        },
      },
      간접시간Hr: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div align="right">${sumText}</div>
            <div align="right">${avgText}</div>
          `;
        },
      },
      전체시간Hr: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div align="right">${sumText}</div>
            <div align="right">${avgText}</div>
          `;
        },
      },
      직접인원수: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div align="right">${sumText}</div>
            <div align="right">${avgText}</div>
          `;
        },
      },
      간접인원수: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div align="right">${sumText}</div>
            <div align="right">${avgText}</div>
          `;
        },
      },
      전체인원수: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div align="right">${sumText}</div>
            <div align="right">${avgText}</div>
          `;
        },
      },
      직접생산성Hr: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:green; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:green; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      전체생산성Hr: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:green; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:green; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      인당직접생산금액: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:purple; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:purple; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      인당전체생산금액: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:purple; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:purple; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      일일직접금액합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:deepskyblue; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:deepskyblue; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      일일간접금액합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:deepskyblue; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:deepskyblue; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      일일총금액합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:deepskyblue; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:deepskyblue; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      직접자재비용합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:greenyellow; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:greenyellow; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      전체자재비용합계: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:greenyellow; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:greenyellow; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      파막금액비율: {
        template(summary) {
          const sum = summary.sum;
          // 외부에서 정의된 총합 변수 사용
          const valueTotalSum_출하피막금액합계 = typeof totalSum_출하피막금액합계 === "number" ? totalSum_출하피막금액합계 : 0;
          const valueTotalSum_출하전체금액합계 = typeof totalSum_출하전체금액합계 === "number" ? totalSum_출하전체금액합계 : 0;

          // 비율 계산
          const ratio = valueTotalSum_출하전체금액합계 !== 0 ? (valueTotalSum_출하피막금액합계 / valueTotalSum_출하전체금액합계) * 100 : 0;
          const sumText = sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = ratio !== 0 ? `${ratio.toFixed(1)}` : "";

          return `
            <div style="text-align:right; color:orange; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:orange; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      도포금액비율: {
        template(summary) {
          const sum = summary.sum;
          // 외부에서 정의된 총합 변수 사용
          const valueTotalSum_출하도포금액합계 = typeof totalSum_출하도포금액합계 === "number" ? totalSum_출하도포금액합계 : 0;
          const valueTotalSum_출하전체금액합계 = typeof totalSum_출하전체금액합계 === "number" ? totalSum_출하전체금액합계 : 0;

          // 비율 계산
          const ratio = valueTotalSum_출하전체금액합계 !== 0 ? (valueTotalSum_출하도포금액합계 / valueTotalSum_출하전체금액합계) * 100 : 0;
          const sumText = sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = ratio !== 0 ? `${ratio.toFixed(1)}` : "";

          return `
            <div style="text-align:right; color:orange; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:orange; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      영업이익: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:teal; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:teal; padding-right:0px;">${avgText}</div>
          `;
        },
      },
      경상이익: {
        template(summary) {
          const sum = summary.sum;
          const avg = summary.avg;
          const sumText = typeof sum === "number" && sum !== 0 ? sum.toLocaleString("ko-KR") : "";
          const avgText = typeof avg === "number" && avg !== 0 ? Math.round(avg).toLocaleString("ko-KR") : "";
          return `
            <div style="text-align:right; color:teal; padding-right:0px;">${sumText}</div>
            <div style="text-align:right; color:teal; padding-right:0px;">${avgText}</div>
          `;
        },
      },
    },
  };

  //한글 및 테마설정--정적api 문서 확이해서 적용할것.
  const Gr = require("tui-grid");
  Gr.setLanguage("ko");
  Gr.applyTheme("striped", {
    //프리징(고정) 영역 테두리
    frozenBorder: {
      border: "#42a5f5", //세로선 색상
    },
    //아웃라인 설정
    outline: {
      border: "#59b9ea",
      showVerticalBorder: false, //수직선표시여부
    },

    cell: {
      //일반 셀 스타일
      normal: {
        background: "pink",
        border: "#DCDCDC",
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      //헤더 셀 스타일
      header: {
        background: "#DCDCDC",
        border: "#C0C0C0",
        text: "blue",
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      //행 헤더 스타일
      rowHeader: {
        background: "#DCDCDC",
        border: "#C0C0C0",
        text: "blue",
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      //선택된 행 헤더 스타일
      selectedRowHead: {
        background: "#e5f6ff",
        showVerticalBorder: true,
      },
      summary: {
        // background: '#C0C0C0',
        // border: '#C0C0C0',
        background: "#DCDCDC",
        border: "#C0C0C0",
        text: "blue",
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
    },
    //헤드영역
    area: {
      header: {
        border: "#59b9ea",
        background: "silver",
        fontSize: "30px",
        showVerticalBorder: true,
        showHorizontalBorder: true,
      },
      //본문
      body: {
        border: "blue", // 본문 영역 테두리 색상
        background: "white", // 본문 영역 배경색 (흰색)
        showVerticalBorder: true, // 수직 테두리 표시
        showHorizontalBorder: true, // 수평 테두리 표시
      },
      summary: {
        border: "#59b9ea", // 요약 영역 테두리 색상
        background: "pink", // 요약 영역 배경색 (분홍색)
        showVerticalBorder: true, // 수직 테두리 표시
        showHorizontalBorder: true, // 수평 테두리 표시
      },
    },

    //호버설정/홀수짝수배경색
    row: {
      even: {
        background: "#ffffff", // 짝수행 배경색 (흰색)
      },
      odd: {
        background: "#e9ecef", // 홀수행 배경색 (연한 회색)
      },
      hover: {
        background: "silver", // 행에 마우스 오버시 배경색 (은색)
      },
    },
  });

  return (
    <>
      {loading ? <ProductivityLoading /> : null}
      <div style={{ textAlign: "center" }}>
        <Box sx={{ ml: 3 }}>
          <h3 style={{ paddingBottom: "10px", marginTop: "20px", textAlign: "center", color: "blue" }}>
            {" "}
            <span style={{ color: "green", textDecoration: "underline", marginRight: "2px" }}>{gongjang.value ? gongjang.value : "[정진/제이콥]"}</span>
            <span>생산성분석</span>
          </h3>
          <form onSubmit={handleSubmitSerche} style={{ marginBottom: "10px" }}>
            <div className="input-group mb-12">
              <CssAutocomplete
                size="small"
                style={{ width: 200, marginRight: 3 }}
                options={gongjangtData}
                getOptionLabel={(option) => option.label}
                getOptionSelected={(option, value) => String(option.value) === String(value.value)}
                value={gongjangtData.find((option) => option.value === gongjang.value) || null}
                onChange={(event, newValue) => {
                  setGongjang(newValue || gongjangtData[0]);
                }}
                renderOption={(option, state) => (
                  <span {...state.props}>
                    {option.label === "정진/제콥" ? (
                      <span
                        style={{
                          color: "gold", // 더 밝은 노란색
                          fontWeight: "bold",
                          // backgroundColor: "", // 배경색 추가
                          // padding: "2px 4px",
                          borderRadius: "3px",
                          textAlign: "left",
                        }}
                      >
                        {option.label}
                      </span>
                    ) : (
                      option.label
                    )}
                  </span>
                )}
                renderInput={(params) => <TextField {...params} label="우리공장" variant="outlined" />}
              />
              {/* 업체명/코드 */}
              <Autocomplete
                size="small"
                style={{ width: 200, marginRight: 3 }}
                options={selectData}
                getOptionLabel={(option) => option.label}
                getOptionSelected={(option, value) => String(option.value) === String(value.value)}
                value={valueSelectCustomer || null}
                onChange={(event, newValue) => {
                  setValueSelectCustomer(newValue);
                }}
                renderInput={(params) => <TextField {...params} label="업체" variant="outlined" />}
              />
              {/* 생산작업장 선택 필드 */}
              <FormControl variant="outlined" style={{ minWidth: 200, marginRight: "4px" }} size="small">
                <InputLabel>생산작업장</InputLabel>
                <Select
                  variant="outlined"
                  value={jacUpJang || ""}
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value !== "") {
                      JacUpJangHandle(event);
                    }
                  }}
                  label="생산작업장"
                  MenuProps={{
                    anchorOrigin: { vertical: "bottom", horizontal: "left" },
                    transformOrigin: { vertical: "top", horizontal: "left" },
                    getContentAnchorEl: null,
                    PaperProps: {
                      style: { maxHeight: 450, marginTop: 8 },
                    },
                  }}
                  // X 아이콘을 표시하기 위한 endAdornment 추가
                  endAdornment={
                    jacUpJang && (
                      <IconButton
                        size="small"
                        style={{ marginRight: 8 }}
                        onClick={(e) => {
                          e.stopPropagation();
                          // 선택값 초기화
                          JacUpJangHandle({ target: { value: "" } });
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )
                  }
                >
                  <MenuItem value="" disabled>
                    <div style={{ color: "green", textDecoration: "underline", justifyContent: "left", display: "flex", width: "100%" }}>--정진선택--</div>
                  </MenuItem>

                  <MenuItem value={"수동피막피착"} style={{ justifyContent: "left" }}>
                    수동피막피착
                  </MenuItem>
                  <MenuItem value={"자동피막_AB"} style={{ justifyContent: "left" }}>
                    자동피막_AB
                  </MenuItem>
                  <MenuItem value={"정진생산납품"} style={{ justifyContent: "left" }}>
                    정진생산납품
                  </MenuItem>
                  <MenuItem value={"정진피막관리"} style={{ justifyContent: "left" }}>
                    정진피막관리
                  </MenuItem>
                  <MenuItem value={"정진피막별정"} style={{ justifyContent: "left" }}>
                    정진피막별정
                  </MenuItem>

                  <MenuItem value="" disabled>
                    <div style={{ color: "green", textDecoration: "underline", justifyContent: "left", display: "flex", width: "100%" }}>--제콥선택--</div>
                  </MenuItem>

                  <MenuItem value={"자동수지도포"} style={{ justifyContent: "left" }}>
                    자동수지도포
                  </MenuItem>
                  <MenuItem value={"수동수지도포"} style={{ justifyContent: "left" }}>
                    수동수지도포
                  </MenuItem>
                  <MenuItem value={"수동캠록도포"} style={{ justifyContent: "left" }}>
                    수동캠록도포
                  </MenuItem>
                  <MenuItem value={"제콥생산납품"} style={{ justifyContent: "left" }}>
                    제콥생산납품
                  </MenuItem>
                  <MenuItem value={"제콥도포관리"} style={{ justifyContent: "left" }}>
                    제콥도포관리
                  </MenuItem>
                  <MenuItem value={"제콥도포별정"} style={{ justifyContent: "left" }}>
                    제콥도포별정
                  </MenuItem>
                </Select>
              </FormControl>
              <TextField
                variant="outlined"
                size="small"
                style={{ width: 150, marginLeft: "0px", marginRight: "2px", float: "center" }}
                label="생산성시작일자"
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                variant="outlined"
                size="small"
                style={{ width: 150, marginLeft: "0px", marginRight: "10px", float: "center" }}
                label="생산성끝날일자"
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Button type="submit" variant="contained" style={{ background: "#0277bd", color: "white", height: 36, width: 120, marginRight: 3, float: "center" }}>
                <i className="fa-solid fa-magnifying-glass" style={{ fontSize: "16px" }}></i>
                조회
              </Button>
              <Button
                id="homemove"
                variant="contained"
                startIcon={<HomeIcon />}
                style={{ background: "#004d40", color: "white", height: 36, width: 120, float: "center" }}
                onClick={() => {
                  // window.location.href = "/home/index";
                  history.goBack();
                }}
              >
                홈이동
              </Button>
            </div>
          </form>
          <Container maxWidth="xl" style={{ padding: "0px 10px 0px 0px" }}>
            <Box style={{ border: "1px solid", borderColor: "#42a5f5", borderRadius: "1px" }}>
              <Grid
                columns={columns}
                data={rows}
                header={header}
                summary={summary}
                scrollY={false}
                rowHeight={"auto"}
                minRowHeight={20}
                //bodyHeight={650}
                bodyHeight={"auto"}
                heightResizable={true}
                virtualScrolling={true}
                // rowHeaders={rowHeaders}
                usageStatistics={false}
                pageOptions={{ useClient: true, perPage: 18 }}
                columnOptions={{
                  minWidth: 50, //첫번째 칼럼의 넗이
                  // frozenCount: 7, // 7개의 컬럼을 고정하고
                  frozenBorderWidth: 1, // 고정 컬럼의 경계선 너비를 2px로 한다.
                  resizable: true,
                }}
                // ref={gridRef}
                // onClick={handleEditClick}
                // onDblclick={handleEditDbClick}
                // onChange={handlEditingFinish}
              />
            </Box>
          </Container>
        </Box>
      </div>
    </>
  );
}
export default Productivity;
